export const AdminCardsData = [
  {
    link: "/admin/dashboard/manage-categories",
    image: "fas fa-project-diagram",
    title: "Manage Categories",
    description: "Create, update and delete categories.",
  },
  {
    link: "/admin/dashboard/manage-products",
    image: "fas fa-shopping-basket",
    title: "Manage products",
    description: "Create, update and delete products.",
  },
  {
    link: "/admin/dashboard/manage-orders",
    image: "fas fa-dollar-sign",
    title: "View Orders",
    description: "Check customer orders and sales amount.",
  },
  {
    link: "/admin/dashboard/privacy-settings",
    image: "fas fa-user-secret",
    title: "Privacy Settings",
    description: "View and update your profile data.",
  },
];

export const UserCardsData = [
  {
    link: "/cart",
    image: "fas fa-shopping-cart",
    title: "Cart",
    description: "Buy products in your cart.",
  },
  {
    link: "/wishlist",
    image: "fas fa-heart",
    title: "Wishlist",
    description: "View your favorite products.",
  },
  {
    link: "/user/dashboard/orders",
    image: "fas fa-credit-card",
    title: "Your orders",
    description: "View your order history data.",
  },
  {
    link: "/user/dashboard/reviews/reviews-list",
    image: "fas fa-star",
    title: "Your reviews",
    description: "View your reviews list.",
  },
  {
    link: "/user/dashboard/privacy-settings",
    image: "fas fa-user-secret",
    title: "Privacy Settings",
    description: "View and update your profile data.",
  },
];
